(function () {

    'use strict';

    angular.module('FotocApp')
 
    .component('tutoIosFacebook', {
          
        templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH )  + 'editor/tutorial/tutoIosFacebook.component.html',
        bindings: { },
        controller: ['$scope','$tutorialService','$editorService', '$canvasService', '$lang', 'CONSTANTS', function ($scope, $tutorialService, $editorService, $canvasService, $lang, CONSTANTS) {

            var self = this;

            this.$tutorialService = $tutorialService;
            this.$editorService = $editorService;
            $scope.$lang =  $lang;

            this.$onInit = function () {

            }

            this.close = function(){
                $tutorialService.close();
            }

        }]
    })
})();